<template>
  <div class="col-md-8">
    <div class="card">
      <div class="card-header">
        <!-- <h4 class="card-title mb-0">Historial Plantillas</h4>
        <div class="card-options text-right">demo</div> -->
        <div class="header-top">
          <h4 class="m-0">Historial Plantillas</h4>
          <div class="card-header-right-icon">
            <button class="btn btn-default" @click="showModal">
              <i class="fa fa-plus"> Agregar Plantilla</i>
            </button>
          </div>
        </div>
      </div>
      <div class="table-responsive add-project">
        <table class="table card-table table-vcenter text-nowrap">
          <thead>
            <tr>
              <th class="text-center">#</th>
              <th>Plantilla</th>
              <th>Creación</th>
              <th class="text-center">Estado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="item.id">
              <td class="text-center">
                <a class="text-inherit" href="#">{{ index + 1 }} </a>
              </td>
              <td>{{ item.name }}</td>
              <td>
                <span class="status-icon bg-success"></span>
                {{ formatTimestampToDate(item.created_at) }}
              </td>
              <td class="text-center">
                <i class="fa fa-check-circle" v-show="item.state"></i>
              </td>
              <td class="text-end">
                <a
                  class="btn btn-primary btn-sm"
                  @click="downloadTemplate(item.id, item.name)"
                  ><i class="fa fa-download"></i> Descargar</a
                >
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "@/includes/connection";

// openModal
const emit = defineEmits(["openModal", "reload"]);
const props = defineProps({ list: Array });
const showModal = () => {
  //console.log("open modal");
  emit("openModal");
};

const downloadTemplate = async (id, fileName) => {
  try {
    const response = await axios.get(`/certification/download/${id}`, {
      responseType: "blob", // Important for handling binary data
    });

    // Create a URL for the blob and download it
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName + ".docx"); // Use the actual file name
    document.body.appendChild(link);
    link.click();

    // Clean up
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading template:", error);
  }
};

function formatTimestampToDate(timestamp) {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}
</script>
